module.exports = __webpack_public_path__ + "img/sv69on.d7edee54.svg";